import { render, staticRenderFns } from "./DatosEmpresa.vue?vue&type=template&id=3751b526&scoped=true"
import script from "./DatosEmpresa.vue?vue&type=script&lang=js"
export * from "./DatosEmpresa.vue?vue&type=script&lang=js"
import style0 from "./DatosEmpresa.vue?vue&type=style&index=0&id=3751b526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3751b526",
  null
  
)

export default component.exports